import { BaseError } from "src/contexts/_shared/domain/errors/BaseError";

export class InvalidHTTPCodeError extends BaseError {
  constructor(code: string) {
    super(`Invalid HTTP Code: ${code}`);
  }
}
